import React, { useEffect, useState } from "react";
import { PostFieldLabel, PlatformUsage } from "components/Posts/PostForm";
import { FIELDS } from "constants/PostFormFields";
import { useDebouncedCallback } from "use-debounce";
import { Input } from "@/components/ui/input";
import { useRegisterFlush } from "../platform-fields/flush-registry";

const PinterestTitle = ({
  url,
  post,
  field,
  checkSetting = false,
  selectedPlatform,
  selectedAccounts,
  platforms,
  title,
  className = "",
  onChange,
  disabled = false,
}) => {
  const [value, setValue] = useState(post.piTitle ?? "");

  useEffect(() => {
    const externalValue = post.piTitle ?? "";
    setValue((currentValue) =>
      currentValue === externalValue ? currentValue : externalValue
    );
  }, [post.piTitle]);

  const bounce = useDebouncedCallback((nextValue) => {
    const currentTitle = post["piTitle"] ?? "";
    if (nextValue !== currentTitle) {
      onChange(nextValue);
    }
  }, 200);
  useRegisterFlush(bounce.flush);

  return (
    <div className={className}>
      <div className="flex flex-col mb-4">
        <div className="flex items-center">
          <PostFieldLabel className="mb-2 mr-2">{title}</PostFieldLabel>
          <PlatformUsage
            platforms={platforms}
            field={FIELDS.PI_TITLE}
            selectedPlatform={selectedPlatform}
          />
        </div>
        <Input
          value={value}
          disabled={disabled}
          placeholder="The title of your pin"
          aria-invalid={value.length > 100 || undefined}
          className="h-8 !border-neutral-100 px-3.5 py-1.5 font-normal aria-invalid:!border-red-500 aria-invalid:!shadow-[0_0_0_2px_rgba(239,68,68,0.08),0_1px_2px_rgba(16,24,40,0.05)]"
          onChange={(event) => {
            const nextValue = event.target.value;
            setValue(nextValue);
            bounce(nextValue);
          }}
        />
        {value.length > 100 && (
          <p className="mt-1 font-inter text-sm font-normal leading-5 text-red-500">
            Pin title must be 100 characters or fewer.
          </p>
        )}
      </div>
    </div>
  );
};

export default PinterestTitle;
